import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  provideSolComponents,
  provideSolHttpClient,
  provideSolDebug,
  provideSolLocale,
  provideSolStorage,
  provideSolTheme,
} from '@sol/components';
import { environment } from '../environments/environment';
import { provideAsmComponents } from '@asm/components-core/providers/provide-asm-components';
import * as packageJson from '../../package.json';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    ...provideSolHttpClient({ authentication: false, mocks: environment.HTTP_MOCKS }),
    provideSolComponents(packageJson.version),
    provideSolDebug(environment.ENV),
    provideSolStorage(environment.APP),
    provideSolTheme(environment.THEME),
    provideSolLocale(['asm-external', 'asm-components-core', 'sol-components']),
    provideAsmComponents(environment.ENV, environment.ASM_API_URL),
  ],
};
